// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".accordion-container[data-v-830ffa86]{flex-flow:column wrap;flex-basis:100%}@media (min-width:768px){.accordion-container[data-v-830ffa86]{flex-basis:49.4%}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
